import { showApiError, useMutation } from '@fv/client-core'
import type { TestInvoiceRequest } from '@fv/models/admin'

import { adminFetch } from '@/utils'

const parseLoadInvoice = (loadId: string) => (body: TestInvoiceRequest) =>
  adminFetch(`/invoices/${loadId}/test`, {
    method: 'POST',
    body,
  })

export const useParseLoadInvoice = (loadId: string) => {
  return useMutation(parseLoadInvoice(loadId), {
    onError(e) {
      showApiError('Error parsing load invoice', e)
    },
    retry: false,
  })
}
